import { Controller } from "@hotwired/stimulus";

/* stimulusFetch: 'lazy' */
export default class FileDownloadController extends Controller {
    static values = {
        url:         String,
        contentType: String,
        filename:    String,

        method: { type: String, default: 'POST' },
    };

    /**
     * @returns {string}
     */
    get url() {
        return this.urlValue;
    }

    /**
     * @returns {string|null}
     */
    get contentType() {
        return this.hasContentTypeValue
            ? this.contentTypeValue
            : null;
    }

    /**
     * @returns {string}
     */
    get filename() {
        return this.filenameValue.replace(/%?!&*:#|"'`<>\{};,=\\\//g, '_');
    }

    /**
     * @returns {string}
     */
    get method() {
        return this.methodValue;
    }

    connect() {
        this.element.addEventListener('click', this._onClick)
    }

    disconnect() {
        this.element.removeEventListener('click', this._onClick)
    }

    _onClick = () => {
        this.execute();
    };

    async execute() {
        this.element.ariaInvalid = null;
        this.element.ariaBusy    = 'true';

        try {
            await this._fetch();
        } catch {
            this.element.ariaInvalid = 'download';
        }

        this.element.ariaBusy = null;
    }

    async _fetch() {
        const response = await fetch(this.url, {
            method: this.method,
        });

        if (!response.ok) {
            throw new Error('Download failed');
        }

        const data = await response.blob();
        const blob = new Blob([data], { type: this.contentType });

        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            // IE and Edge, probably
            window.navigator.msSaveOrOpenBlob(blob, this.filename);
        } else {
            const url     = URL.createObjectURL(blob);
            const link    = document.createElement('a');
            link.href     = url;
            link.download = this.filename;
            link.click();

            setTimeout(() => {
                URL.revokeObjectURL(url);
            }, 250);
        }
    }
}
